import { Grid } from "../../core/components/grid";
import { ToolBarStandardButton, ToolBarStandardButtonType } from "../../core/components/toolBar";
import { Config } from "../../core/config/config";
import { DialogHelper } from "../../core/util/dialogHelper";
import { Helper } from "../../core/util/helper";
import { HTTPService, JsonResultClass } from "../../core/util/httpManager";
import { NotificationHelper } from "../../core/util/notificationHelper";
import { Currency } from "./dialogs/currencyDialog";
import { InternalCurrency, OpenMainGroupInternalCurrencyDialog } from "./dialogs/internalCurrencyDialog";
import React from "react";
interface MainGroupInternalCurrenciesProps {
    idCurr: number;
    gridOptions: any;
}

export default class MainGroupInternalCurrenciesGrid extends React.Component<MainGroupInternalCurrenciesProps, {
    selectedItem: InternalCurrency,
    enableDeleteButton: boolean,
    gridData: InternalCurrency
}>{

    constructor(props) {
        super(props);
        this.state = {
            selectedItem: null,
            enableDeleteButton: false,
            gridData: null
        }
    }

    componentDidMount() {
        this.loadGridData();
    }

    componentDidUpdate(prevProps: MainGroupInternalCurrenciesProps) {
        let idChanged = prevProps.idCurr != this.props.idCurr;
        if (idChanged)
            this.loadGridData();
    }

    private loadGridData = async () => {
        let result = await HTTPService.get<JsonResultClass<InternalCurrency>>("GeneralSettingsCurrency/GetInternalCurrencies?idCurr=" + this.props.idCurr);
        if (result.Code == 0)
            this.setState({ gridData: result.Data });
        else
            NotificationHelper.showErrorMessage(result.Message);
    }

    private onSelectedChange = (dataItem: InternalCurrency) => {
        if (Helper.hasValue(dataItem)) {
            this.setState({ enableDeleteButton: dataItem.IsDeletable, selectedItem: dataItem });
        }
    }

    private _handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: Currency) => {
        if (type == ToolBarStandardButtonType.EDIT) {
            this.onEditInternalCurrency(dataItem);
        } else if (type == ToolBarStandardButtonType.NEW) {
            this.onCreateNewInternalCurrency();
        } else if (type == ToolBarStandardButtonType.DELETE) {
            DialogHelper.confirm(Helper.getTranslation("Standard.Msg.Loeschen")).then(isOk => {
                if (isOk) {
                    this.deleteInternalCurrency(dataItem.GUID);
                }
            });
        }
    }

    private onEditInternalCurrency = async (sourceCurrency: InternalCurrency) => {
        let currency = await OpenMainGroupInternalCurrencyDialog(this.props.idCurr, sourceCurrency);
        sourceCurrency.Currency = currency.Currency;
        sourceCurrency.From = currency.From;
        sourceCurrency.To = currency.To;
        sourceCurrency.Name = currency.Name;
        this.changeInternalCurrency(sourceCurrency);
    }

    private changeInternalCurrency = async (currency: InternalCurrency) => {
        let result = await HTTPService.post<JsonResultClass>("GeneralSettingsCurrency/ChangeInternalCurrency", currency);
        if (result.Code == 0) {
            this.setState({}, () => this.loadGridData());
        }
        else
            NotificationHelper.showErrorMessage(result.Message);
    }

    private onCreateNewInternalCurrency = async () => {
        let currency = await OpenMainGroupInternalCurrencyDialog(this.props.idCurr);
        currency.Id = this.props.idCurr;
        this.createNewInternalCurrency(currency);
    }

    private createNewInternalCurrency = async (currency: InternalCurrency) => {
        let result = await HTTPService.post<JsonResultClass<number>>("GeneralSettingsCurrency/CreateNewInternalCurrency", currency);
        if (result.Code == 0) {
            this.setState({}, () => this.loadGridData());
        }
        else
            NotificationHelper.showErrorMessage(result.Message);
    }

    private deleteInternalCurrency = async (isGuid: string) => {
        let result = await HTTPService.post<JsonResultClass>("GeneralSettingsCurrency/DeleteInternalCurrency?isGuid=" + encodeURIComponent(isGuid));
        if (result.Code == 0) {
            this.setState({}, () => this.loadGridData());
        }
        else
            NotificationHelper.showErrorMessage(result.Message);
    }

    private createGrid = () => {
        let grid = null;
        let fullLoaded: boolean = Helper.hasValue(this.state.gridData) && Helper.hasValue(this.props.gridOptions);

        if (fullLoaded) {
            const standardButtons: Array<ToolBarStandardButton> = [];
            standardButtons.push({ type: ToolBarStandardButtonType.NEW, caption: Config.translations.newLabel, enabled: true });
            standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: Config.translations.editLabel, enabled: true });
            standardButtons.push({ type: ToolBarStandardButtonType.DELETE, caption: Config.translations.deleteLabel, enabled: this.state.enableDeleteButton });
            grid =
                <Grid data={this.state.gridData} options={this.props.gridOptions} id="internalCurrenciesIdGrid" onSelectionChanged={this.onSelectedChange}
                    standardButtons={standardButtons} onClickStandardButton={this._handleClickStandardButton}
                />;
        }
        return grid;
    }

    render() {
        const grid = this.createGrid();
        return (<>
            {grid}
        </>)
    }
}